import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../../pages/popup/Popup01"
import Popup02 from "../../pages/popup/Popup02"
import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';

import * as API from "../../libs/service";
import { logIn } from '../../redux/usersSlice';
import moment from 'moment';

export default function Register() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);
    const { mbData } = useSelector((s) => s.usersReducer);

    const terms = useSelector((s) => s.etcReducer.terms);
    const serviceTermsSub = terms?.Terms?.[lang === 0 ? 'ko' : 'en']?.sub || ''
    const privacySub = terms?.Collection?.[lang === 0 ? 'ko' : 'en']?.sub || ''
    const marketingSub = terms?.Marketing?.[lang === 0 ? 'ko' : 'en']?.sub || ''

    const [nameTitleView, setNameTitleView] = useState(false);
    const [nameValue, setNameValue] = useState('');
    const [nameAster, setNameAster] = useState(true);
    const [nameErr, setNameErr] = useState(0);

    const [idTitleView, setIdTitleView] = useState(false);
    const [idValue, setIdValue] = useState('');
    const [idAster, setIdAster] = useState(true);
    const [idErr, setIdErr] = useState(0);

    const [pwSuc, setPwSuc] = useState(false);

    const [pwTitleView, setPwTitleView] = useState(false);
    const [pwview, setPwview] = useState(false);
    const [pwValue, setPwValue] = useState('');
    const [pwAster, setPwAster] = useState(true);

    const [pwChkTitleView, setPwChkTitleView] = useState(false);
    const [pwChkview, setPwChkview] = useState(false);
    const [pwChkValue, setPwChkValue] = useState('');
    const [pwChkAster, setPwChkAster] = useState(true);
    const [pwErr, setPwErr] = useState(0);
    const [pwChkErr, setPwChkErr] = useState(0);

    const [code, setCode] = useState('');
    const [notcode, setNotcode] = useState(true);
    const [codeErr, setCodeErr] = useState(false);

    const [time, setTime] = useState(180);
    const [timecut, setTimecut] = useState(false);

    const [registerStep, setRegisterStep] = useState(0);

    const [chkSuc, setChkSuc] = useState(false);
    const [chkValueOne, setChkValueOne] = useState(false);
    const [chkValueTwo, setChkValueTwo] = useState(false);
    const [chkValueThree, setChkValueThree] = useState(false);

    useEffect(() => {
        if (mbData?.idx) {
            navigate(routes.main);
        }
    }, [navigate]);

    useEffect(() => {
        setRegisterStep(0)
    }, []);

    useEffect(() => {
        if (chkValueOne && chkValueTwo) {
            setChkSuc(true);
        } else {
            setChkSuc(false);
        }
    }, [chkValueOne, chkValueTwo]);

    useEffect(() => {
        if (registerStep === 2 && time > 0) {
            const timer = setInterval(() => {
                setTime(prevTime => {
                    if (prevTime === 1) {
                        setTimecut(true);
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        } else if (time === 0) {
            setTimecut(true);
        }
    }, [registerStep, time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const ReCode = async () => {
        await CodeFunc();
        setTime(180);
        setTimecut(false);
        setCode('');
        setNotcode(true);
    };

    const CodeFunc = async () => {
        let sender = {
            email: idValue,
            language: lang === 0 ? 'ko' : 'en'
        };

        dispatch(loadingStart());

        await API.post('user/RegisterCode', sender).then(({ data }) => {
            console.log('data', data);
            if (data?.msg === 'err1') {
                loginFunc("email");
            } else {
                setRegisterStep(2)
            }

        }).catch(err => {
            /* console.log(err.response.data) */
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            navigate(routes.login)
                        }}
                    />
            }));
        }).finally(() => {
            dispatch(loadingEnd());
        })
    }

    const CodeChkFunc = async () => {
        let sender = {
            email: idValue,
            code: code
        };

        await API.post('user/RegisterCodeChk', sender).then(({ data }) => {
            /* console.log('인증번호 체크', data); */

            setCodeErr(false);
            setRegisterStep(3);

        }).catch(err => {
            /* console.log(err.response.data); */
            setCodeErr(true);
        }).finally(() => {

        })
    }

    const RegisterFunc = async () => {
        //     data.username = data.username || data.email;
        // data.fullname = data.fullname || data.email;
        // data.countryCode = data.countryCode || 'US';
        // data.language = data.language || 'en';
        // data.validType = data.validType || 'valid';
        // let sender = {
        //     mb_name: nameValue,
        //     email: idValue,
        //     password: pwValue,
        //     agree: chkValueThree ? 1 : 0
        // };
        let sender = {
            email: idValue,
            password: pwValue,
            // countryCode: lang === 0 ? 'KR' : 'US',
            // language: lang === 0 ? 'ko' : 'en',
            isAcceptMarketing: chkValueThree ? 1 : 0,
            isAcceptTermsOfService: 1,
            isAcceptPrivacyPolicy: 1,
        };

        /* console.log(sender); */

        dispatch(loadingStart());

        await API.post('user/RegisterIn', sender).then(({ data }) => {
            /* console.log('체크', data); */

            setTimeout(() => {
                localStorage.setItem('regiSuc', '1');
                navigate(routes.login);
            }, 2000);

        }).catch(err => {
            /* console.log(err.response.data); */
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            navigate(routes.login)
                        }}
                    />
            }));
        }).finally(() => {
            setTimeout(() => {
                dispatch(loadingEnd());
            }, 2000);
        })
    }

    const loginFunc = (type) => {
        if (type === "email") {
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        text1={lang === 0 ? '이미 가입된 계정입니다.' : 'This account is already registered.'}
                        longButton={lang === 0 ? '로그인' : 'Login'}
                        setFunc={() => {
                            navigate(routes.login)
                        }}
                    />
            }));
        }

        if (type === "google") {
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        loginPop_navi_google={true}
                    />
            }));
        }
    }

    const InputChange = (event) => {
        const { name, value } = event.target;

        /* if(name === "login_name") {
            let NameChk = /^[가-힣a-zA-Z]*$/;
            setNameValue(value)

            if(value) {
                setNameAster(false);
                setNameTitleView(true)
            } else {
                setNameAster(true);
                setNameTitleView(false)
            }

            if(!NameChk.test(value)) {
                setNameErr(1);
                return;
            } else {
                setNameErr(0);
            }
        } */

        if (name === "login_id") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setIdValue(value)

            if (value) {
                setIdAster(false);
                setIdTitleView(true)
            } else {
                setIdAster(true);
                setIdTitleView(false)
            }

            if (!EmailChk.test(value)) {
                setIdErr(2);
                return;
            } else {
                if (!value.endsWith('@umodeler.com') && /\+[0-9]+(?=@)/.test(value)) {
                    setIdErr(2);
                    return;
                }
                setIdErr(0);
            }
        }

        if (name === "login_password") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwValue(value)

            if (value) {
                setPwAster(false);
                setPwTitleView(true)
            } else {
                setPwAster(true);
                setPwTitleView(false)
            }

            if (pwChkValue != value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
                setPwSuc(true)
            }

            if (!pwChk.test(value)) {
                setPwErr(1)
            } else {
                setPwErr(0)
            }

            if (pwChkValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }

        if (name === "login_password_chk") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwChkValue(value)

            if (value) {
                setPwChkAster(false);
                setPwChkTitleView(true)
            } else {
                setPwChkAster(true);
                setPwChkTitleView(false)
            }

            if (pwValue != value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
            }

            if (!pwChk.test(value)) {
                setPwErr(1)
                setPwSuc(false)
            } else {
                setPwErr(0)
            }

            if (pwValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }

        if (name === "code") {
            const onlyNumbers = /^[0-9]*$/;
            setCode(value);

            if (onlyNumbers.test(value)) {
                if (value.length == 4) {
                    setNotcode(false);
                } else {
                    setNotcode(true);
                }
            }
        }
    }

    const StepChkFunc = (step) => {
        if (step == 1) {
            setRegisterStep(1)
        }

        if (step == 2) {
            let NameChk = /^[가-힣a-zA-Z]*$/;
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            /* if(!nameValue) {
                dispatch(open({
                    component: 
                        <Popup01 
                            x_btn={true}
                            text1={'이름을 입력해 주세요.'}
                            longButton={'확인'}
                        />
                }));
                return;
            } */

            if (!idValue) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '이메일을 입력해 주세요.' : 'Please enter your email.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));
                return;
            }

            if (!EmailChk.test(idValue)) {
                setIdErr(2);
                return;
            } else {
                setIdErr(0);
                CodeFunc();
            }

            /* if(!NameChk.test(nameValue)) {
                setNameErr(1);
                return;
            } else {
                setNameErr(0);
            }

            if (EmailChk.test(idValue) && NameChk.test(nameValue)) {
                CodeFunc();
            } */

        }

        if (step == 3) {

        }
    }

    const checkboxFunc = (event) => {
        const { id, checked } = event.target;

        if (id === "term_chk1") {
            setChkValueOne(checked);
        } else if (id === "term_chk2") {
            setChkValueTwo(checked);
        } else if (id === "term_chk3") {
            setChkValueThree(checked);
        }
    }

    const LoginFunc = async () => {
        let sender = {
            email: idValue,
            password: pwValue,
        };

        await API.post('user/Login', sender).then(({ data }) => {
            if (data?.msg === 'err1') {
                setIdErr(1);
            } else if (data?.msg === 'err2') {
                setPwErr(1);
            } else if (data?.msg === 'err3') {
                setIdErr(1);
            } else {
                setIdErr(0);
                setPwErr(0);
                dispatch(loadingStart());
                setTimeout(() => {
                    LoginSucFunc(data);
                    dispatch(loadingEnd());
                }, 2000);
            }
        }).catch(err => {
            console.log("err : ", err);
            if (err.response && err.response.status === 404) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? 'ID 나 비밀번호가 일치하지 않습니다.' : 'Incorrect ID or password.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.login);
                            }}
                        />
                }));
            } else {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.login);
                            }}
                        />
                }));
            }
        });
    };
    
    const LoginSucFunc = (data) => {
        dispatch(
            logIn({
                mbData: {
                    idx: data?.id,
                    mb_type: data?.validType,
                    mb_email: data?.email,
                    mb_name: data?.fullname,
                    pwCount: pwValue?.length,
                    lang: data?.language === 'ko' ? 0 : 1,
                    countryCode: data?.countryCode,
                    isAcceptMarketingActivities: data?.isAcceptMarketingActivities,
                    emailLanguage: data?.emailLanguage,
                },
                autoLogin: moment(),
            })
        );
        navigate(routes.main);
    };

    // Google Identity Services 로그인 처리 함수
    const handleGoogleSignIn = () => {
        const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
        const redirectUri = process.env.REACT_APP_GOOGLE_AUTH_CALLBACK_URL;
        const scope = 'openid email profile';
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&prompt=select_account`;
        window.location.href = googleAuthUrl;
    };

    const loginPop = (type, email) => {
        if (type === "login") {
            if (!idValue || !pwValue) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '아이디 또는 비밀번호를 입력해 주세요.' : 'Please enter your ID or password.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));
            } else {
                LoginFunc();
            }
        }
        if (type === "email") {
            if (email) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_pw={false}
                            text1={lang === 0 ? '이메일로 가입된 계정입니다.' : 'This account was registered via email.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                setIdAster(false);
                                setIdErr(0);
                                setIdValue(email);
                            }}
                        />
                }));
            } else {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_pw={true}
                            text1={lang === 0 ? '이메일로 가입된 계정입니다.' : 'This account was registered via email.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.Login_pw_help);
                            }}
                        />
                }));
            }
        }
        if (type === "google") {
            if (email) {
                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            loginPop_navi_google={true}
                            text1={'구글로 가입된 계정입니다.'}
                            text1_b={email}
                            longButton={lang === 0 ? '확인' : 'OK'}
                            setFunc={() => {
                                navigate(routes.Login_pw_help);
                            }}
                        />
                }));
            } else {
                handleGoogleSignIn();
            }
        }
    };


    const handleCredentialResponse = (response) => {
        console.log("Google ID Token:", response.credential);
        // 이곳에서 response.credential (JWT)을 백엔드로 전송하여 로그인 처리, 회원가입 처리
        API.post('user/googleLogin', { token: response.credential })
            .then(({ data }) => {
                console.log("data : ", data);
                if (data?.msg === 'success') {
                    LoginSucFunc(data);
                } else {
                    if (data?.msg === 'err1') {
                        loginPop("email", data?.email);
                    }
                }
            })
            .catch((err) => {
                toast(lang === 0 ? '구글 로그인 중 오류가 발생했습니다.' : 'An error occurred during Google login.');
            });
    };

    return (
        <>
            <div className="login_back register">
                <div className="login_box">
                    {/* <div>
                        <p onClick={() => {setRegisterStep(1)}}>1</p>
                        <p onClick={() => {setRegisterStep(2)}} style={{margin: '20px 0'}}>2</p>
                        <p onClick={() => {setRegisterStep(3)}}>3</p>
                    </div> */}
                    <div
                        className="logo"
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            navigate(routes.login)
                        }}
                    >
                        <img src={require("../../assets/icon/logo1.svg").default} />
                    </div>

                    {registerStep == 0 &&
                        <>
                            <p className="title">{lang === 0 ? '회원가입' : 'Sign up'}</p>

                            <div className="login_input_box regi">
                                <button
                                    type="button"
                                    className="sns_login_btn google"
                                    onClick={() => {
                                        console.log("login!!!!!");
                                        //handleGoogleSignIn();
                                    }}
                                >
                                    <img src={require("../../assets/icon/google.svg").default} />
                                    {lang === 0 ? 'Google로 가입 (준비중)' : 'Google Sign up (Preparing)'}
                                </button>
                                <span style={{ color: '#666' }}>{lang === 0 ? '또는' : 'or'}</span>

                                <button
                                    type="button"
                                    className="register_btn regi"
                                    onClick={() => {
                                        StepChkFunc(1)
                                    }}
                                    style={{
                                        color: '#fff',
                                        backgroundColor: '#0E6AF4'
                                    }}
                                >
                                    {lang === 0 ? '이메일로 가입' : 'Sign up'}
                                </button>

                            </div>
                        </>
                    }

                    {registerStep == 1 &&
                        <>
                            <p className="title">{lang === 0 ? '이메일로 회원 가입하기' : 'Sign Up with Email'}</p>
                            <span
                                style={{
                                    color: '#666',
                                    marginTop: '-32px'
                                }}
                            >
                                {lang === 0 ? '안전한 서비스 제공을 위해 이메일 인증이 필요합니다.' : 'Email verification is required to provide a secure service.'}
                            </span>

                            <div className="login_input_box">
                                {/* <div className="input_div">
                                    {nameTitleView &&
                                        <div className="input_focus id_focus">
                                            <p>이름</p>
                                            <span 
                                                className="input_aster"
                                                style={{
                                                    left: '22px',
                                                    top: '-2px'
                                                }}
                                            >
                                                *
                                            </span>
                                        </div>
                                    }
                                    <input 
                                        type="text" 
                                        placeholder="이름" 
                                        className="input_id"
                                        name="login_name"
                                        value={nameValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setNameTitleView(false)
                                        }}
                                        maxLength={10}
                                    />
                                    {nameAster && 
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: '50px',
                                                top: nameTitleView ? '20px' : '15px'
                                            }}
                                        >
                                            *
                                        </span>
                                    }
                                </div>
                                {nameErr == 1 && <span className="err_msg id">이름이 올바르지 않습니다.</span>} */}

                                <div
                                    className="input_div"
                                    style={{
                                        border: idTitleView ? '1px solid #0E6AF4' : ''
                                    }}
                                >
                                    {idTitleView &&
                                        <div className="input_focus id_focus">
                                            <p>{lang === 0 ? '이메일' : 'Email'}</p>
                                            <span
                                                className="input_aster"
                                                style={{
                                                    left: lang === 0 ? '32px' : '30px',
                                                    top: '-2px'
                                                }}
                                            >
                                                *
                                            </span>
                                        </div>
                                    }
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? '이메일' : 'Email'}
                                        className="input_id"
                                        name="login_id"
                                        value={idValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setIdTitleView(false)
                                        }}
                                    />
                                    {idAster &&
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '64px' : '60px',
                                                top: idTitleView ? '20px' : '15px'
                                            }}
                                        >
                                            *
                                        </span>
                                    }
                                </div>
                                {idErr == 2 && <span className="err_msg id">{lang === 0 ? '이메일 형식이 올바르지 않습니다.' : 'The email format is incorrect.'}</span>}

                                <button
                                    type="button"
                                    className="login_btn regi"
                                    onClick={() => {
                                        StepChkFunc(2)
                                    }}
                                >
                                    {lang === 0 ? '인증번호 받기' : 'Receive Code'}
                                </button>

                                {/* <button 
                                    type="button" 
                                    className="login_btn regi"
                                    onClick={() => {
                                        loginFunc("email")
                                    }}
                                >
                                    이미 가입된 계정일 시
                                </button> */}

                                {/* <button 
                                    type="button" 
                                    className="login_btn regi"
                                    onClick={() => {
                                        loginFunc("google")
                                    }}
                                >
                                    구글로 가입된 계정일 시
                                </button> */}
                            </div>
                        </>
                    }

                    {registerStep == 2 &&
                        <>
                            <p className="title">{lang === 0 ? '이메일로 회원 가입하기' : 'Sign Up with Email'}</p>
                            <span
                                style={{
                                    fontSize: '16px',
                                    marginBottom: '-20px'
                                }}
                            >
                                {lang === 0 ? '가입하신 이메일로 인증번호를 보내드립니다.' : 'Verification code will be sent to the email you registered.'}
                            </span>

                            <div className="login_input_box">
                                <div className="input_div" style={{ background: '#f1f1f1' }}>
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? '이메일' : 'Email'}
                                        className="input_id"
                                        name="login_id"
                                        value={idValue}
                                        style={{ background: '#f1f1f1' }}
                                        readOnly
                                    />
                                </div>

                                <span className="err_msg id" style={{ color: '#0E6AF4' }}>{lang === 0 ? '이메일로 인증번호를 전송했습니다.' : 'Verification code has been sent to your email.'}</span>

                                <div
                                    className="input_div"
                                    style={{
                                        marginTop: '20px',
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? "인증번호 입력" : 'Enter Code'}
                                        className="input_id"
                                        name="code"
                                        value={code}
                                        onChange={InputChange}
                                        maxLength={4}
                                    />
                                    <span
                                        style={{
                                            color: '#0E6AF4',
                                            fontSize: '12px',
                                            position: 'absolute',
                                            right: '12px',
                                            top: 'calc(50% - 10px)'
                                        }}
                                    >
                                        {formatTime(time)}
                                    </span>
                                </div>

                                {codeErr &&
                                    <span className="err_msg id">{lang === 0 ? '인증번호가 일치하지 않습니다.' : 'The verification code does not match.'}</span>
                                }

                                <button
                                    type="button"
                                    className="login_btn regi"
                                    onClick={() => {
                                        if (!notcode && !timecut) {
                                            CodeChkFunc()
                                        }
                                        if (timecut) {
                                            dispatch(open({
                                                component:
                                                    <Popup01
                                                        x_btn={true}
                                                        text1={lang === 0 ? '인증번호가 만료되었습니다.' : 'The code has expired.'}
                                                        longButton={lang === 0 ? '확인' : 'OK'}
                                                    />
                                            }));
                                        }
                                    }}
                                    style={{
                                        background: notcode ? '#ccc' : ''
                                    }}
                                >
                                    {lang === 0 ? '확인' : 'OK'}
                                </button>

                                {timecut &&
                                    <button
                                        type="button"
                                        className="login_btn regi"
                                        onClick={() => {
                                            ReCode()
                                        }}
                                    >
                                        {lang === 0 ? '재요청' : 'Resend'}
                                    </button>
                                }
                            </div>
                        </>
                    }

                    {registerStep == 3 &&
                        <>
                            <p className="title">{lang === 0 ? '이메일로 회원 가입하기' : 'Sign Up with Email'}</p>

                            <input
                                type="text"
                                placeholder={lang === 0 ? '이메일' : 'Email'}
                                className="input_id"
                                name="login_id"
                                value={idValue}
                                readOnly
                                style={{ fontWeight: '700' }}
                            />

                            <span
                                style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    color: '#666',
                                    marginTop: '-32px'
                                }}
                            >
                                {lang === 0 ? '비밀번호(8~15자리 영문,숫자,특수문자 혼합)' : 'Password (8-15 characters, mix of letters, numbers, and special characters)'}
                            </span>

                            <div
                                className="input_div pw_div"
                                style={{
                                    marginTop: '-20px',
                                    border: pwTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                {pwTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>{lang === 0 ? '비밀번호' : 'Password'}</p>
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '42px' : '54px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input
                                    type={!pwview ? "password" : "text"}
                                    placeholder={lang === 0 ? '비밀번호' : 'Password'}
                                    className="input_pw"
                                    name="login_password"
                                    value={pwValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setPwTitleView(false)
                                    }}
                                    maxLength={15}
                                />
                                {!pwview ?
                                    <img
                                        src={require("../../assets/icon/eye_off.svg").default}
                                        onClick={() => {
                                            setPwview(true)
                                        }}
                                    />
                                    :
                                    <img
                                        src={require("../../assets/icon/eye_on.svg").default}
                                        onClick={() => {
                                            setPwview(false)
                                        }}
                                    />
                                }
                                {pwAster &&
                                    <span
                                        className="input_aster"
                                        style={{
                                            left: lang === 0 ? '76px' : '92px',
                                            top: pwTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>

                            <div
                                className="input_div pw_div"
                                style={{
                                    marginTop: '-32px',
                                    border: pwChkTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                {pwChkTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>{lang === 0 ? '재입력' : 'Re-enter'}</p>
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '32px' : '48px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input
                                    type={!pwChkview ? "password" : "text"}
                                    placeholder={lang === 0 ? '재입력' : 'Re-enter'}
                                    className="input_pw"
                                    name="login_password_chk"
                                    value={pwChkValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setPwChkTitleView(false)
                                    }}
                                    maxLength={15}
                                />
                                {!pwChkview ?
                                    <img
                                        src={require("../../assets/icon/eye_off.svg").default}
                                        onClick={() => {
                                            setPwChkview(true)
                                        }}
                                    />
                                    :
                                    <img
                                        src={require("../../assets/icon/eye_on.svg").default}
                                        onClick={() => {
                                            setPwChkview(false)
                                        }}
                                    />
                                }
                                {pwChkAster &&
                                    <span
                                        className="input_aster"
                                        style={{
                                            left: lang === 0 ? '64px' : '85px',
                                            top: pwChkTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>
                            {pwChkErr == 1 && <span className="err_msg id" style={{ marginTop: '-32px' }}>{lang === 0 ? '비밀번호가 일치하지 않습니다.' : 'Passwords do not match.'}</span>}
                            {pwErr == 1 && <span className="err_msg id" style={{ marginTop: '-32px' }}>{lang === 0 ? '비밀번호 형식이 올바르지 않습니다.' : 'The password format is incorrect.'}</span>}

                            <div className="register_suc_btn_box" style={{ marginTop: '-20px' }}>
                                <div className="register_chk_box">
                                    <div className="custom_chk_box">
                                        <input
                                            type="checkbox"
                                            className="custom_chk_input"
                                            id="term_chk1"
                                            checked={chkValueOne}
                                            onChange={checkboxFunc}
                                        />
                                        <label htmlFor="term_chk1" className="custom_chk_label">{lang === 0 ? '[필수] ' : '[Required] '}{serviceTermsSub}</label>
                                        <img
                                            src={require("../../assets/icon/right_arr_gray.svg").default}
                                            onClick={() => {
                                                dispatch(open({
                                                    component:
                                                        <Popup02
                                                            x_btn={true}
                                                            register_term1={true}
                                                            maxwidth={600}
                                                        />
                                                }));
                                            }}
                                        />
                                    </div>

                                    <div className="custom_chk_box">
                                        <input
                                            type="checkbox"
                                            className="custom_chk_input"
                                            id="term_chk2"
                                            checked={chkValueTwo}
                                            onChange={checkboxFunc}
                                        />
                                        <label htmlFor="term_chk2" className="custom_chk_label">{lang === 0 ? '[필수] ' : '[Required] '}{privacySub}</label>
                                        <img
                                            src={require("../../assets/icon/right_arr_gray.svg").default}
                                            onClick={() => {
                                                dispatch(open({
                                                    component:
                                                        <Popup02
                                                            x_btn={true}
                                                            register_term2={true}
                                                            maxwidth={600}
                                                        />
                                                }));
                                            }}
                                        />
                                    </div>

                                    <div className="custom_chk_box">
                                        <input
                                            type="checkbox"
                                            className="custom_chk_input"
                                            id="term_chk3"
                                            checked={chkValueThree}
                                            onChange={checkboxFunc}
                                        />
                                        <label htmlFor="term_chk3" className="custom_chk_label">{lang === 0 ? '[선택] ' : '[Optional] '}{marketingSub}</label>
                                        <img
                                            src={require("../../assets/icon/right_arr_gray.svg").default}
                                            onClick={() => {
                                                dispatch(open({
                                                    component:
                                                        <Popup02
                                                            x_btn={true}
                                                            register_term3={true}
                                                            maxwidth={600}
                                                        />
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="login_btn regi"
                                    onClick={() => {
                                        if (chkSuc && pwSuc) {
                                            RegisterFunc()
                                        }
                                    }}
                                    style={{
                                        background: !chkSuc || !pwSuc ? '#ccc' : ''
                                    }}
                                >
                                    {lang === 0 ? '가입 완료' : 'Complete'}
                                </button>
                            </div>
                        </>
                    }
                </div>
            </div>
            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
